import PropTypes from 'prop-types';
import React from 'react';

import Row from 'components/Row';
import Col from 'components/Col';

const SummaryField = ({label, value, ...props}) => {
  return <Col sm={3} {...props}>
    <label>{label}</label>
    <p>{value}</p>
  </Col>;
};

SummaryField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
};

const PrintableReport = ({tableData, tableColumns, summaryData, summaryColumns, start, end, title, startLabel, endLabel, formatMessage}) => {
  return <div>
    <Row className='well' style={{padding: '20px 0px', margin: '10px 0px'}}>
      <Col sm={12}><label style={{fontSize: '20px'}}>{title}</label></Col>
      <SummaryField label={startLabel ? startLabel : formatMessage({id: 'general.start.date'})} value={start} />
      <SummaryField label={endLabel ? endLabel : formatMessage({id: 'general.start.date'})} value={end} />
    </Row>
    {summaryData && summaryColumns ?
      <Row className='well' style={{padding: '20px 0px', margin: '10px 0px'}}>
        {summaryColumns.map(c => <SummaryField key={c.key} label={c.name}
                                               value={c.format ? c.format(summaryData[c.key]) : summaryData[c.key]}
                                               style={{paddingBottom: 10}} />)}
      </Row> :
      null}
    {tableColumns && tableData ?
      <table className='table-biolab table-striped'>
        <thead>
          <tr>{tableColumns.map(h => <th key={h.key}>{h.name}</th>)}</tr>
        </thead>
        <tbody>
          {tableData.map((row, i) => <tr key={i}>
            {tableColumns.map(h => <td key={h.key}>{h.format ? h.format(row[h.key]) : row[h.key]}</td>)}
          </tr>)}
        </tbody>
      </table> :
      null}
  </div>;
};

PrintableReport.propTypes = {
  end: PropTypes.string.isRequired,
  endLabel: PropTypes.string.isRequired,
  formatMessage: PropTypes.any,
  start: PropTypes.string.isRequired,
  startLabel: PropTypes.string.isRequired,
  summaryColumns: PropTypes.array,
  summaryData: PropTypes.any,
  tableColumns: PropTypes.array,
  tableData: PropTypes.any,
  title: PropTypes.string,
};

export default PrintableReport;
